import { useMemo } from 'react';

import HighchartsReact from 'highcharts-react-official';
import { useYearQuarterNavigation } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import getHighchartsInstance from 'utils/charts';
import { getLocalizedMonthNames } from 'utils/date';

import { capacityBalanceAtom, showPerFunctionAtom } from '../../atoms';

import { formatCapacityBalanceDataForGraph } from '../../util';
import { StyledPaper } from 'components/shared/Paper/StyledPaper.styles';

const Highcharts = getHighchartsInstance();

const CapacityBalanceGraph = () => {
  const { t } = useTranslation('common');

  const { isViewPerWeek } = useYearQuarterNavigation();
  const showPerFunction = useRecoilValue(showPerFunctionAtom);
  const capacityBalance = useRecoilValue(capacityBalanceAtom);

  const series = useMemo(() => {
    if (capacityBalance) {
      return formatCapacityBalanceDataForGraph(
        capacityBalance,
        showPerFunction,
        t
      );
    }
    return [];
  }, [capacityBalance, showPerFunction]);

  const options = {
    title: {
      text: undefined
    },

    chart: {
      type: 'line'
    },

    xAxis: {
      categories: isViewPerWeek
        ? capacityBalance?.periodHourBalances.map(
            ({ number }) => `${t('week')} ${number}`
          )
        : getLocalizedMonthNames()
    },

    yAxis: {
      allowDecimals: true,
      title: {
        text: t('hours')
      },
      plotLines: [
        {
          color: '#000000',
          width: 2,
          value: 0,
          zIndex: 2
        }
      ]
    },

    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },

    series,

    credits: {
      enabled: false
    }
  };

  return (
    <StyledPaper>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </StyledPaper>
  );
};

export default CapacityBalanceGraph;
